import { useState } from "react";
import { DeliveryBoy } from "./DeliveryBoy";
import { SamplePickUpBoy } from "./SamplePickUpBoy";
import { DriverProvider } from "../../Clinic/Driver/DriverContext";
import DriverUpdateComponent from "../../Clinic/Driver/updateDriver.tsx/updateDetails";

export function DriverListing() {
  const [activeTab, setActiveTab] = useState<"delivery" | "pickup">("delivery");
  const [selectedDriverId, setSelectedDriverId] = useState<string | null>(null);
  const [showDriverUpdateModal, setShowDriverUpdate] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);

  const handleViewButton = (id: string) => {
    setSelectedDriverId(id);
    setShowDriverUpdate(true);
    setIsUpdate(false);
  };

  const handleCloseUpdateModal = () => {
    setShowDriverUpdate(false);
  };

  return (
    <DriverProvider>
      {showDriverUpdateModal ? (
        <DriverUpdateComponent
          driverId={selectedDriverId}
          onClose={handleCloseUpdateModal}
          isUpdate={isUpdate}
        />
      ) : (
        <div className="p-6 max-w-[1600px] mx-auto space-y-6">
          {/* Top Header */}
          <div>
            <h1 className="text-xl font-bold text-gray-900">Drivers</h1>
            <p className="text-xs text-gray-500 mt-0.5">
              View all delivery boys and sample pickup personnel across clinics
            </p>
          </div>

          <div className="p-4 bg-white rounded-xl border border-gray-100 shadow-sm">
            {/* Tab Switch */}
            <div className="flex space-x-8 border-b border-gray-200">
              <button
                onClick={() => setActiveTab("delivery")}
                className={`pb-3 px-1 font-medium text-sm whitespace-nowrap relative ${
                  activeTab === "delivery"
                    ? "text-green-600 border-b-2 border-green-600"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                Delivery Boy
              </button>
              <button
                onClick={() => setActiveTab("pickup")}
                className={`pb-3 px-1 font-medium text-sm whitespace-nowrap relative ${
                  activeTab === "pickup"
                    ? "text-green-600 border-b-2 border-green-600"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                Sample Pickup Person
              </button>
            </div>

            {/* Conditional Component Rendering */}
            {activeTab === "delivery" ? (
              <DeliveryBoy handleViewButton={handleViewButton} />
            ) : (
              <SamplePickUpBoy handleViewButton={handleViewButton} />
            )}
          </div>
        </div>
      )}
    </DriverProvider>
  );
}
